/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/no-did-mount-set-state */
import * as React from 'react';

type InsCardPropType = {
  dataWidth: string;
  dataHeight: string;
  iframeProps: any;
  onInsClick: (data: any) => void;
} & Partial<DefaultProps>;

interface InsCardStateType {
  iframeHeight: number;
}

type DefaultProps = Readonly<typeof defaultProps>;

const defaultProps = {
  onInsClick: (data: any) => {
    // empty
  },
};

export class InsCard extends React.Component<
  InsCardPropType,
  InsCardStateType
> {
  static defaultProps: DefaultProps = defaultProps;

  state: InsCardStateType = {
    iframeHeight: Number(this.props.iframeProps.height) || 0,
  };

  private readonly iframeRef: any = React.createRef<HTMLIFrameElement>();

  componentDidMount() {
    const { dataWidth, dataHeight } = this.props;
    const width = Number(dataWidth) || 1;
    const height = Number(dataHeight) || 1;
    // ins的iframe缩放时header 54px和footer 44px不变
    const insUnresizeHeight = 54 + 44;
    // 如果没有宽高，那么默认1:1
    const ratio = (height - insUnresizeHeight) / width;
    const iframe = this.iframeRef && this.iframeRef.current;
    if (iframe) {
      const iframeWidth = iframe.clientWidth;
      this.setState({
        iframeHeight: Math.floor(iframeWidth * ratio) + insUnresizeHeight,
      });
    }
  }

  handleInsClick: () => void = () => {
    const { onInsClick } = this.props;
    if (this.iframeRef && this.iframeRef.current) {
      let { src: href } = this.iframeRef.current;
      href = href.replace(/embed.*/, '');
      // window.open(href);
      if (onInsClick && typeof onInsClick === 'function') {
        onInsClick({
          href,
        });
      }
    }
  };

  render() {
    const { dataWidth, dataHeight, iframeProps } = this.props;
    const { iframeHeight } = this.state;
    return (
      <div
        className="ins-container"
        data-width={dataWidth}
        data-height={dataHeight}
        style={{ height: iframeHeight, overflow: 'hidden' }}
        onClick={this.handleInsClick}>
        <iframe
          ref={this.iframeRef}
          {...iframeProps}
          allowTransparency={true}
          allowFullScreen={true}
          height={iframeHeight}></iframe>
      </div>
    );
  }
}
